import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreatePopularQuestion extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PopularQuestion/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllPopularQuestions extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PopularQuestion/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdatePopularQuestion extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PopularQuestion/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeletePopularQuestion extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PopularQuestion/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreatePopularQuestion,
  GetAllPopularQuestions,
  UpdatePopularQuestion,
  DeletePopularQuestion,
};
